<template>
  <div style="width:100%;height:100%;background:#151515">
     <el-row style="width:100%;height:50px;line-height:50px;color:#cccccc;text-align:left">
      <el-col :offset="1">当前项目GUID：{{project.srcaddress}}</el-col>
     </el-row>
    <el-row style="width:100%;height:calc(100% - 50px);">
     <el-form id="where" style="height:50px" label-position="right"  label-width="75px" :model="where">
  <el-row>
    <el-col :span="8">
       <el-form-item style="color:#ffffff;text-align:left" label="时间"  prop="name">
    <el-date-picker
        v-model="where.date"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      size="small"
      value-format="yyyy-MM-dd HH:mm:ss"
      :default-time="['00:00:00','23:59:59']"
      end-placeholder="结束日期">
    </el-date-picker>
  </el-form-item>
    </el-col>
    <el-col :span="6">
      <el-form-item style="color:#ffffff;text-align:left" label="设备"  prop="name">
    <el-select size="mini" style="width:100%" clearable  v-model="where.deviceid" placeholder="请选择设备">
        <el-option v-for="d in deviceList" :label="d.roomname+'-'+d.name" :value="d.innerid" :key="d.innerid"></el-option>
      </el-select>
  </el-form-item>
    </el-col>
      <el-col :span="6">
      <el-form-item style="color:#ffffff;text-align:left" label="关键字"  prop="name">
    <el-input size="mini" style="width:70%;float:left" v-model="where.keyword"></el-input>
  </el-form-item>
    </el-col>
    <el-col :span="4" style="text-align:left">
    <el-button size="small" type="warning" icon="el-icon-search" title="查询" @click="search()">查询</el-button>
    <el-button size="small" type="success" icon="el-icon-plus" title="新增" @click="add()"></el-button>
    </el-col>
  </el-row>
</el-form>
       <el-row style="height:calc(100% - 50px)">
           <el-table
          :data="tabledata"
          size="mini"
          ref="table"
          stripe
          height="calc(100% - 60px)"
          style="width: 95%;margin:0 auto; background:#f0f9eb;border:0"
          :header-cell-style="{ 'text-align': 'center','background':'#868686','color':'#fff' }"
          :row-class-name="tableRowClassName"
          :cell-style="{ height: '40px', padding: '0', 'text-align': 'center','font-size':'12px' }">
          <template slot="empty">
                 <div>该项目暂无日志记录
              </div>
          </template>
           <el-table-column
            type="index"
            :index="indexMethod"
            width="50">
          </el-table-column>
          <el-table-column
            prop="createdtime"
             width="180"
            label="时间">
          </el-table-column>
           <el-table-column
            prop="devicename"
            width="180"
            label="设备">
          </el-table-column>
          <el-table-column
            prop="name"
             width="150"
            label="操作">
          </el-table-column>
          <el-table-column
            prop="value"
             width="200"
            label="当前值">
          </el-table-column>
            <el-table-column
            prop="desc"
             width="250"
            label="变动详情">
          </el-table-column>
          <el-table-column
            prop="remark"
            label="留言备注"
            >
             <template slot-scope="scope">
              <div style="display:inline">{{scope.row.remark}}<i style="color:orange" class="el-icon-edit" @click="editRemark(scope.row)">{{scope.row.remark?'':'点击添加'}}</i></div>
              </template>
          </el-table-column>
           </el-table>
        <el-pagination
          background
          hide-on-single-page
          :page-sizes="[50,100,200,500]"
          :current-page="pageset.index"
          :page-size="pageset.size"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total,sizes,prev, pager, next"
          :total="totalsize"
          style="float: right; margin-top: 10px;"
        >
        </el-pagination>
       </el-row>
    </el-row>
    <el-dialog width="450px" title="添加记录" :visible.sync="dialogTableVisible">
  <el-form ref="log" id="newlog" :rules="rules" :model="log" label-width="80px" style="text-align:left;margin-top:10px;width:400px">
    <el-form-item label="备注" prop="remark">
      <el-input v-model="log.remark" size="mini" placeholder="请输入内容"></el-input>
    </el-form-item>
    <el-form-item label="关联设备" prop="deviceid">
      <el-select size="mini" style="width:100%" v-model="log.deviceid" placeholder="请选择关联设备">
        <el-option v-for="d in deviceList" :label="d.roomname+'-'+d.name" :value="d.innerid" :key="d.innerid"></el-option>
      </el-select>
    </el-form-item>
     <el-form-item label="关联时间" prop="createdtime" >
       <el-date-picker
       :clearable="false"
      v-model="log.createdtime"
      type="datetime"
       size="mini"
      value-format="yyyy-MM-dd HH:mm:ss"
      style="width:100%"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogTableVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitForm()">确 定</el-button>
  </div>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Report',
  data () {
    return {
      allDevice:[],
       rules: {
          remark: [
            { required: true, message: '请输入备注信息', trigger: 'blur' },
            { min: 5, message: '至少输入三个字符', trigger: 'blur' }
          ],
          deviceid: [
            { required: true, message: '请选择关联设备', trigger: 'change' }
          ],
           createdtime: [
            { required: true, message: '请输入关联时间', trigger: 'change' }
          ]
        },
      dialogTableVisible:false,
      where: {date: [], keyword: ''},
      project: {},
      pageset: {
        size: 50,
        index: 1
      },
      totalsize: 0,
      tabledata: [],
      log:{deviceid:null,createdtime:null,remark:''}
    }
  },
  computed: {
    deviceList:function(){
      if(this.project.protocolid===227){
        return this.allDevice.filter(d=>{return [222,227,228,229].includes(d.protocolid)})
      }else{
        return this.allDevice.filter(d=>{return [150,151,161].includes(d.protocolid)})
      }
    }
  },
  mounted: function () {
    let project = window.localStorage.getItem('project')
    if (project) {
      this.project = JSON.parse(project)
      if(this.project.innerid != this.project.projectid) {
        this.project.innerid = this.project.projectid
      }
      this.where.projectid = this.project.innerid
      this.where.aio = (this.project.protocolid === 227)
      this.search()
      let self=this
          Vue.axios
      .post('/api/cchv/device/list', {projectid: this.project.innerid})
      .then((res) => {
        if (res.data.errcode == 0) {
          self.allDevice = res.data.msgbody
        }
      })
    } else {
      this.$router.push({ name: 'Login' })
    }
  },
  methods: {
    indexMethod: function (index) {
      return (this.pageset.index - 1) * this.pageset.size + index + 1
    },
    search: function () {
      let self = this
      if (this.where.date.length > 0) {
        this.where.startdate = this.where.date[0]
        this.where.enddate = this.where.date[1]
      }
      Vue.axios.post('/aio/log/list', {
        where: this.where,
        pageset: this.pageset
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
          }
        })
      Vue.axios.post('/aio/log/list/count', {
        where: this.where
      })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.totalsize = res.data.msgbody
          }
        })
    },
    tableRowClassName ({row, rowIndex}) {
      if (rowIndex % 2 === 1) {
        return 'srow'
      }
      return ''
    },
    handleSizeChange (val) {
      this.pageset.size = val
      this.search()
    },
    handleCurrentChange (val) {
      this.pageset.index = val
      this.search()
    },
    editRemark (row) {
      this.$prompt('请输入备注信息', '备注', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        inputValue: row.remark
      }).then(({ value }) => {
        Vue.axios.post('/aio/log/edit', {
          innerid: row.innerid,
          remark: value
        })
          .then((res) => {
            if (res.data.errcode == 0) {
              row.remark = value
            } else {
              this.$message.error('保存失败')
            }
          })
      }).catch(() => {

      })
    },
    add(){
      this.log={projectid:this.project.innerid, deviceid:null,createdtime:(new Date()).Format('yyyy-MM-dd HH:mm:00'),remark:''}
      this.dialogTableVisible = true
    },
    submitForm() {
        this.$refs['log'].validate((valid) => {
          if (valid) {
             Vue.axios.post('/aio/log/add', this.log)
          .then((res) => {
            if (res.data.errcode == 0) {
           this.$message({
          message: '保存成功',
          type: 'success'
        });
        this.search()
        this.dialogTableVisible=false;
            } else {
              this.$message.error('保存失败')
            }
          }).catch(() => {

      })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
  }
}


Date.prototype.Format = function (formatStr) {
  var str = formatStr
  var Week = ['日', '一', '二', '三', '四', '五', '六']

  str = str.replace(/yyyy|YYYY/, this.getFullYear())
  str = str.replace(
    /yy|YY/,
    this.getYear() % 100 > 9
      ? (this.getYear() % 100).toString()
      : '0' + (this.getYear() % 100)
  )

  str = str.replace(
    /MM/,
    this.getMonth() > 8 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1)
  )
  str = str.replace(/M/g, this.getMonth())

  str = str.replace(/w|W/g, Week[this.getDay()])

  str = str.replace(
    /dd|DD/,
    this.getDate() > 9 ? this.getDate().toString() : '0' + this.getDate()
  )
  str = str.replace(/d|D/g, this.getDate())

  str = str.replace(
    /hh|HH/,
    this.getHours() > 9 ? this.getHours().toString() : '0' + this.getHours()
  )
  str = str.replace(/h|H/g, this.getHours())
  str = str.replace(
    /mm/,
    this.getMinutes() > 9
      ? this.getMinutes().toString()
      : '0' + this.getMinutes()
  )
  str = str.replace(/m/g, this.getMinutes())

  str = str.replace(
    /ss|SS/,
    this.getSeconds() > 9
      ? this.getSeconds().toString()
      : '0' + this.getSeconds()
  )
  str = str.replace(/s|S/g, this.getSeconds())

  return str
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

#newlog .el-form-item__label{
  color:#999999
}

#where .el-form-item__label{
  color:#ffffff
}

.el-table .srow {
    background: #f0f1f0;
  }

  .el-pagination__total{
    color:#fff !important;
  }
</style>

<style scoped>

::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #a7a7a7;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #a7a7a7;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/components/Devices/Log.vue